// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1iN1Q","title":"Info_title__2ABcD","links":"Info_links__1qIQh","link":"Info_link__2aoEV","logo":"Info_logo__3WPZ1"};